import React from 'react';
import { useSurveyTheme } from '@sm/webassets';
import { getThemeLayoutType } from '~app/helpers/themeLayout';
import useStyles from './useStyles';

export type LayoutContainerIds = {
  layoutContainer: string;
  partialContainer: string;
  contentContainer: string;
  logoContainer: string;
  toolbarContainer: string;
  mainContent: string;
};
export type Props = React.PropsWithChildren<{
  /** Override any of the container ID's */
  ids?: LayoutContainerIds;
  /** add RTL support (to css) */
  isRTL?: boolean;
  /** An element to show in the logo container */
  logo?: React.ReactElement | false;
  /** Element(s) to show in the toolbar container */
  tools?: React.ReactElement | false;
}>;

function Layout({ ids: containerIds, isRTL = false, logo: Logo, tools: Tools, children }: Props): React.ReactElement {
  const { layout: layoutName } = useSurveyTheme();
  const { isBanner } = getThemeLayoutType(layoutName);
  const isToolbarEnabled = !!Tools;
  const isLogoEnabled = !!Logo;
  const {
    layoutContainer,
    layoutLogoContainer,
    layoutPartialContainer,
    layoutToolbarContainer,
    layoutContentContainer,
    layoutMainContainer,
  } = useStyles({ isRTL });
  const ids = React.useMemo(
    () => ({
      layoutContainer: 'survey-layout-container',
      partialContainer: 'survey-layout-partial-container',
      contentContainer: 'survey-layout-content-container',
      mainContent: 'survey-main-content',
      logoContainer: 'survey-logo-container',
      toolbarContainer: 'survey-toolbar-container',
      ...containerIds,
    }),
    [containerIds]
  );
  return (
    <div id={ids.layoutContainer} className={layoutContainer}>
      <div id={ids.partialContainer} className={layoutPartialContainer}>
        <If condition={isBanner && isLogoEnabled}>
          <div id={ids.logoContainer} className={layoutLogoContainer}>
            {Logo}
          </div>
        </If>
      </div>
      <div id={ids.contentContainer} className={layoutContentContainer}>
        <If condition={isToolbarEnabled}>
          <div id={ids.toolbarContainer} className={layoutToolbarContainer}>
            {Tools}
          </div>
        </If>
        <If condition={!isBanner && isLogoEnabled}>
          <div id={ids.logoContainer} className={layoutLogoContainer}>
            {Logo}
          </div>
        </If>
        <main id={ids.mainContent} tabIndex={-1} className={layoutMainContainer}>
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
